import { BrandColor } from '@dev/ee-api/ee-api-models';

import {
    ActionTypes,
    BrandColorsLoadAction,
    BrandColorsLoadSuccessAction,
    BrandColorsState,
    BrandColorsAddStartAction,
    BrandColorsAddSuccessAction,
    BrandColorsAddErrorAction,
    BrandColorsDeleteStartAction,
    BrandColorsDeleteSuccessAction,
    BrandColorsDeleteErrorAction,
    BrandColorsEditStartAction,
    BrandColorsEditSuccessAction,
    BrandColorsEditErrorAction,
} from './types';
import { ApplicationState } from '..';

export const BrandColorsLoadStart = (): BrandColorsLoadAction => ({
    type: ActionTypes.LOAD_START,
});

export const BrandColorsLoadSuccess = (colors: BrandColor[]): BrandColorsLoadSuccessAction => ({
    type: ActionTypes.LOAD_SUCCESS,
    payload: {
        colors,
    },
});

export const BrandColorsLoadError = () => ({
    type: ActionTypes.LOAD_ERROR,
});

export const BrandColorsAddStart = (color: BrandColor): BrandColorsAddStartAction => ({
    type: ActionTypes.ADD_START,
    payload: {
        color,
    },
});

export const BrandColorsAddSuccess = (colors: BrandColor[]): BrandColorsAddSuccessAction => ({
    type: ActionTypes.ADD_SUCCESS,
    payload: {
        colors,
    },
});

export const BrandColorsAddError = (color: BrandColor): BrandColorsAddErrorAction => ({
    type: ActionTypes.ADD_ERROR,
    payload: {
        color,
    },
});

export const BrandColorsEditStart = (colorIndex: number, color: BrandColor): BrandColorsEditStartAction => ({
    type: ActionTypes.EDIT_START,
    payload: {
        colorIndex,
        color,
    },
});

export const BrandColorsEditSuccess = (colors: BrandColor[]): BrandColorsEditSuccessAction => ({
    type: ActionTypes.EDIT_SUCCESS,
    payload: {
        colors,
    },
});

export const BrandColorsEditError = (color: BrandColor): BrandColorsEditErrorAction => ({
    type: ActionTypes.EDIT_ERROR,
    payload: {
        color,
    },
});

export const BrandColorsDeleteStart = (colorIndex: number, color: BrandColor): BrandColorsDeleteStartAction => ({
    type: ActionTypes.DELETE_START,
    payload: {
        colorIndex,
        color,
    },
});

export const BrandColorsDeleteSuccess = (colors: BrandColor[]): BrandColorsDeleteSuccessAction => ({
    type: ActionTypes.DELETE_SUCCESS,
    payload: {
        colors,
    },
});

export const BrandColorsDeleteError = (color: BrandColor): BrandColorsDeleteErrorAction => ({
    type: ActionTypes.DELETE_ERROR,
    payload: {
        color,
    },
});

export const getBrandColorsStore = (store: ApplicationState): BrandColorsState =>
    store.brandColors || ({} as BrandColorsState);
